// ConsultantShareLedgerModal.helpers.jsx — 상담자배분의 상태 없는 도우미 (2026-10-05 창 290줄에서 분리, 2026-10-06 탭으로 옮김)
import React from 'react';
import { toDateString, toKoreanDateTimeString } from '../../../utils/date';
import { S } from './ConsultantShareLedgerModal.styles';

export function fmtMoney(value) {
  return `${Number(value || 0).toLocaleString('ko-KR')}원`;
}

export function fmtDate(value) {
  return value ? toDateString(value) : '-';
}

export function fmtDateTime(value) {
  return value ? toKoreanDateTimeString(value) : '-';
}

export function statusLabel(row) {
  if (row.decisionStatus === 'excluded') return '제외';
  return row.decisionSource === 'manual' ? '적용' : '자동적용';
}

export function Metric({ label, value }) {
  return (
    <div style={S.metric}>
      <div style={S.metricLabel}>{label}</div>
      <div style={S.metricValue}>{value}</div>
    </div>
  );
}

export function withIntegratedMenu(url, integratedMenuId) {
  if (!integratedMenuId) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}integrated_menu_id=${encodeURIComponent(integratedMenuId)}`;
}
